import { FC, useEffect, useMemo } from 'react'
import { Input, Select } from '@chakra-ui/react'
import { UseFormRegister } from 'react-hook-form'

import { CITIZEN_INITIAL_FILTER_FIELDS } from 'CitizenProfile/constants/pages/citizens'
import { CitizenFieldsName, CitizenFilter } from 'CitizenProfile/types'
import { FormItem, MaskedInput } from 'components'
import { cnsMask, cpfMask, pisMask, rgMask } from 'utils/masks'
import { SEXES_OPTIONS } from 'constants/variables'
import { focusElementById } from 'utils/events'

type Props = {
  register: UseFormRegister<CitizenFilter>
  onlyFields?: CitizenFieldsName[]
  hasPrefix?: boolean
}

const CitizenFilterForm: FC<Props> = ({ hasPrefix, register, onlyFields }) => {
  const citizenFilterFields = useMemo(() => {
    return onlyFields || CITIZEN_INITIAL_FILTER_FIELDS
  }, [])

  function setPrefix(key: any) {
    if (hasPrefix) return `unified_person_${key}`
    return key
  }

  function setLabelWithPrefix(label: string) {
    if (hasPrefix) return `${label} do cidadão`
    return label
  }

  useEffect(() => {
    focusElementById('name')
  }, [])

  return (
    <>
      {citizenFilterFields.includes('id') && (
        <FormItem label="ID" htmlFor="id">
          <Input id="id" {...register(setPrefix('id'))} />
        </FormItem>
      )}
      {citizenFilterFields.includes('name') && (
        <FormItem label={setLabelWithPrefix('Nome')} htmlFor="name">
          <Input id="name" {...register(setPrefix('name'))} />
        </FormItem>
      )}
      {citizenFilterFields.includes('social_name') && (
        <FormItem label={setLabelWithPrefix('Nome social')} htmlFor="social_name">
          <Input id="social_name" {...register(setPrefix('social_name'))} />
        </FormItem>
      )}
      {citizenFilterFields.includes('mother_name') && (
        <FormItem label={setLabelWithPrefix('Nome da mãe')} htmlFor="mother_name">
          <Input id="mother_name" {...register(setPrefix('mother_name'))} />
        </FormItem>
      )}
      {citizenFilterFields.includes('father_name') && (
        <FormItem label={setLabelWithPrefix('Nome do pai')} htmlFor="father_name">
          <Input id="father_name" {...register(setPrefix('father_name'))} />
        </FormItem>
      )}

      {citizenFilterFields.includes('cpf_number') && (
        <FormItem label={setLabelWithPrefix('CPF')} htmlFor="cpf_number">
          <MaskedInput mask={cpfMask} id="cpf_number" {...register(setPrefix('cpf_number'))} />
        </FormItem>
      )}

      {citizenFilterFields.includes('cns_number') && (
        <FormItem label={setLabelWithPrefix('CNS')} htmlFor="cns_number">
          <MaskedInput mask={cnsMask} id="cns_number" {...register(setPrefix('cns_number'))} />
        </FormItem>
      )}

      {citizenFilterFields.includes('ctps_pis_number') && (
        <FormItem label={setLabelWithPrefix('PIS')} htmlFor="ctps_pis_number">
          <MaskedInput mask={pisMask} id="ctps_pis_number" {...register(setPrefix('ctps_pis_number'))} />
        </FormItem>
      )}

      {citizenFilterFields.includes('rg_number') && (
        <FormItem label="RG" htmlFor="rg_number">
          <MaskedInput mask={rgMask} id="rg_number" {...register(setPrefix('rg_number'))} />
        </FormItem>
      )}
      {citizenFilterFields.includes('sex') && (
        <FormItem label={setLabelWithPrefix('Sexo')} htmlFor="sex">
          <Select id="sex" {...register(setPrefix('sex'))}>
            <option value="">Todos</option>
            {SEXES_OPTIONS.map(({ label, value }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </Select>
        </FormItem>
      )}
      {citizenFilterFields.includes('main_address_neighbourhood') && (
        <FormItem label={setLabelWithPrefix('Bairro principal')} htmlFor="main_address_neighbourhood">
          <Input id="main_address_neighbourhood" {...register(setPrefix('main_address_neighbourhood'))} />
        </FormItem>
      )}
      {citizenFilterFields.includes('ethnicity') && (
        <FormItem label={setLabelWithPrefix('Etinia')} htmlFor="ethnicity">
          <Input id="ethnicity" {...register(setPrefix('ethnicity'))} />
        </FormItem>
      )}
      {citizenFilterFields.includes('race') && (
        <FormItem label={setLabelWithPrefix('Raça')} htmlFor="race">
          <Input id="race" {...register(setPrefix('race'))} />
        </FormItem>
      )}
      {citizenFilterFields.includes('origin_id') && (
        <FormItem label={setLabelWithPrefix('ID da origem')} htmlFor="origin_id">
          <Input id="origin_id" {...register(setPrefix('origin_id'))} />
        </FormItem>
      )}
      {citizenFilterFields.includes('jobsite_name') && (
        <FormItem label={setLabelWithPrefix('Posto de trabalho')} htmlFor="jobsite_name">
          <Input id="jobsite_name" {...register(setPrefix('jobsite_name'))} />
        </FormItem>
      )}
      {citizenFilterFields.includes('health_place_name') && (
        <FormItem label={setLabelWithPrefix('Unidade da saúde')} htmlFor="health_place_name">
          <Input id="health_place_name" {...register(setPrefix('health_place_name'))} />
        </FormItem>
      )}
      {citizenFilterFields.includes('school_place_name') && (
        <FormItem label={setLabelWithPrefix('Unidade da educação')} htmlFor="school_place_name">
          <Input id="school_place_name" {...register(setPrefix('school_place_name'))} />
        </FormItem>
      )}
      {citizenFilterFields.includes('social_place_name') && (
        <FormItem label={setLabelWithPrefix('Unidade social')} htmlFor="social_place_name">
          <Input id="social_place_name" {...register(setPrefix('social_place_name'))} />
        </FormItem>
      )}
      {citizenFilterFields.includes('gov_place_name') && (
        <FormItem label={setLabelWithPrefix('Unidade do governo')} htmlFor="gov_place_name">
          <Input id="gov_place_name" {...register(setPrefix('gov_place_name'))} />
        </FormItem>
      )}
    </>
  )
}

export default CitizenFilterForm
